import styles from "../../pages/BlogArticle.module.scss";
import { getGoogleMapEmbedUrl, getSectionId } from "./articleUtils";
import { BlogMedia, getInstagramUrl } from "./InstagramEmbed";
import { useLanguage } from "../../contexts/LanguageContext";
import { blogText } from "../../i18n/blog";

export function SpotArticleTemplate({ article }) {
  const { lang } = useLanguage();
  const spots = Array.isArray(article.spots) ? article.spots : [];

  return (
    <div className={styles.spotList}>
      {spots.map((spot, index) => (
        <SpotCard
          key={spot.number || index}
          spot={spot}
          index={index}
          lang={lang}
        />
      ))}
    </div>
  );
}

function SpotCard({ spot, index, lang }) {
  const t = blogText[lang] || blogText.JP;
  const rows = Array.isArray(spot.rows) ? spot.rows : [];
  const hashtags = Array.isArray(spot.hashtags) ? spot.hashtags : [];
  const images = Array.isArray(spot.images) ? spot.images : [];
  const instagramItems = [
    spot.instagramEmbedUrl,
    spot.instagramPostUrl,
    spot.instagramUrl,
    ...images,
  ].filter((item) => getInstagramUrl(item));
  const hasInstagramEmbed = instagramItems.length > 0;

  const embedMapUrl =
    spot.embedMapUrl ||
    getGoogleMapEmbedUrl(
      spot.mapUrl,
      `${spot.title} ${spot.area || ""} 宮古島`,
    );

  return (
    <section
      id={getSectionId(index)}
      className={`${styles.spotItem} ${hasInstagramEmbed ? styles.instagramSpotItem : ""}`}
    >
      {hasInstagramEmbed && (
        <div className={styles.mobileSpotSummary}>
          <div className={styles.pointHeading}>
            <span>{spot.number}</span>
            <h3>{spot.title}</h3>
            {spot.area && <small>{spot.area}</small>}
          </div>

          {spot.text && <p>{spot.text}</p>}
        </div>
      )}

      {hasInstagramEmbed && (
        <div className={`${styles.spotImages} ${styles.instagramMediaGrid}`}>
          {instagramItems.slice(0, 1).map((image, imageIndex) => (
            <BlogMedia
              key={`${spot.title}-${imageIndex}`}
              media={image}
              alt={`${spot.title} ${t.instagramPostAlt} ${imageIndex + 1}`}
            />
          ))}
        </div>
      )}

      <div className={styles.spotText}>
        <div className={styles.pointHeading}>
          <span>{spot.number}</span>
          <h3>{spot.title}</h3>
          {spot.area && <small>{spot.area}</small>}
        </div>

        {spot.text && <p>{spot.text}</p>}

        {rows.length > 0 && (
          <dl>
            {rows.map(([label, value]) => (
              <div key={label}>
                <dt>{label}</dt>
                <dd>{value}</dd>
              </div>
            ))}
          </dl>
        )}

        {hashtags.length > 0 && (
          <div className={styles.hashtags}>
            {hashtags.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        )}

        {embedMapUrl && (
          <div className={styles.spotMapPanel}>
            <div className={styles.spotMapHeader}>
              <div>
                <span>LOCATION</span>
                <strong>{spot.title}</strong>
                {spot.area && <p>{spot.area}</p>}
              </div>

              {spot.mapUrl && (
                <a href={spot.mapUrl} target="_blank" rel="noreferrer">
                  {t.googleMapOpen}
                </a>
              )}
            </div>

            <div className={styles.spotMapFrame}>
              <iframe
                title={`${spot.title} Google Map`}
                src={embedMapUrl}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
